import React, { useEffect, useState } from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import appPlay from "../assets/images/app-play.svg";
import googlePlay from "../assets/images/google-play.svg";
import mobilApp from "../assets/images/mobil-app.webp";
import whyChooseIcon1 from "../assets/images/whyChoose-icon1.svg";
import whyChooseIcon2 from "../assets/images/whyChoose-icon2.svg";
import whyChooseIcon3 from "../assets/images/whyChoose-icon3.svg";
import whyChooseIcon4 from "../assets/images/whyChoose-icon4.svg";
import featureBanne from "../assets/images/feature.webp";

import tickCircleWhite from "../assets/images/tick-circle-white.svg";
import activity from "../assets/images/activity.svg";
import requiest from "../assets/images/requiest.svg";
import feedback from "../assets/images/feedback.svg";

import keepRequiest from "../assets/images/keep-requiest.svg";
import providQuote from "../assets/images/provid-quote.svg";
import trakProject from "../assets/images/trak-project.svg";
import strimlineProject from "../assets/images/strimline-project.svg";

import Accordion from "react-bootstrap/Accordion";
import { scrollToTop } from "../utils/Helper";

const Features = () => {
  const [activeKey, setActiveKey] = useState("0");
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>
        <section className="join-sec text-center aboutsPage-banner feature-banner">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="bloglist-banner content-block">
                  <h1 className="title h1">
                    Key Features of Joyscore: Unlock Your Best Self
                  </h1>
                  <div className="blog-banner">
                    <img
                      src={featureBanne}
                      alt="featureBanne"
                      className="bloglistBanner"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="client-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Streamline Your Projects & Elevate Client Collaboration</h2>
              <p>
                Keep projects organized, improve communication, and manage tasks
                effortlessly—all in one place.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <Accordion
                  defaultActiveKey="0"
                  activeKey={activeKey}
                  onSelect={(eventKey) => setActiveKey(eventKey)}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                    Centralized Client Communication
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Prevents scattered conversations across emails, sms,
                        texts, and calls.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents scattered conversations across emails, sms,
                            texts, and calls.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps all project discussions in one easy-to-access
                            location.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Provides a clear record of decisions and requests.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                    Change Order Management
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Easily manage out-of-scope requests, approvals, and
                        pricing adjustments.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Tracks out-of-scope requests separately from
                            standard project work.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Simplifies approval and pricing adjustments for
                            extra work.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Ensures all changes are documented, reducing
                            disputes.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Collect & Leverage Client Feedback
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Use one dedicated channel for all project communication,
                        preventing confusion and messy back-and-forth across
                        email and group texts.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents scattered conversations across emails,
                            texts, and calls.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps all project discussions in one easy-to-access
                            location.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Provides a clear record of decisions and requests.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Keep Small Requests Organized
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Track and manage requests efficiently without derailing
                        your project timeline.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Allows clients and service providers to submit small
                            asks in the form of requests without impacting
                            scope.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps requests separate from major change orders for
                            better organization.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents last-minute surprises by ensuring all tasks
                            are documented and addressed.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                    Provide Quoites for Out-Of-Scope Work
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Offer clear pricing options and transparency on project
                        changes.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Attach a quote to change orders with Good, Better,
                            Best pricing options.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Helps clients make informed decisions by comparing
                            different pricing tiers.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Ensures all additional work is approved before
                            impacting scope or budget.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>Track Project Analytics</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Get a high-level view of project progress, deadlines,
                        and financials in one place.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Track active projects, pending approvals, and
                            upcoming deadlines at a glance.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Identify bottlenecks early to keep work moving
                            smoothly.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Gain insights into overall project health,
                            sign-offs, and client engagement.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      Organize & Streamline Project Management
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Use a simple, visual system to track progress, assign
                        tasks, and ensure accountability.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Uses a visual system to track tasks and milestones.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Makes it easy to assign responsibilities and follow
                            progress.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps teams and clients aligned with a clear
                            workflow.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <div className="col-lg-6 col-md-6">
                <Accordion
                  defaultActiveKey="0"
                  activeKey={activeKey}
                  className="accordion-img"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Body>
                      <img src={activity} alt="activity" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Body>
                      <img src={requiest} alt="requiest" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Body>
                      <img src={feedback} alt="feedback" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Body>
                      <img
                        src={keepRequiest}
                        alt="keepRequiest"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Body>
                      <img
                        src={providQuote}
                        alt="providQuote"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Body>
                      <img
                        src={trakProject}
                        alt="trakProject"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Body>
                      <img
                        src={strimlineProject}
                        alt="strimlineProject"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>
        <section className="whyChoose-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Why Choose Us?</h2>
              <p>
                Effortless Project Management, Seamless Client Collaboration
              </p>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon1}
                    alt="whyChooseIcon1"
                    className="whyChooseIcon"
                  />
                  <h4>Client-Centric Approach</h4>
                  <p>
                    We prioritize transparent communication and strong client
                    relationships to ensure smooth collaboration and lasting
                    trust.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon2}
                    alt="whyChooseIcon2"
                    className="whyChooseIcon"
                  />
                  <h4>Efficiency & Automation</h4>
                  <p>
                    Automate processes, reduce manual effort, and keep projects
                    on track with smart, time-saving solutions.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon3}
                    alt="whyChooseIcon3"
                    className="whyChooseIcon"
                  />
                  <h4>Data-Driven Insights</h4>
                  <p>
                    Make informed choices with powerful analytics and real-time
                    reporting for improved project performance.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon4}
                    alt="whyChooseIcon4"
                    className="whyChooseIcon"
                  />
                  <h4>Flexible & Scalable Solutions</h4>
                  <p>
                    Whether you’re a freelancer, small business, or enterprise,
                    HE adapts to your needs and grows with you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Features;
